import { TruckingWhitelistRule } from './rule';

/**
 * How targeted a rule is, used to pick a winner when several match. Qualifiers outrank the carrier
 * token deliberately: if the carrier ranked highest, `!*\/Vanguard` could never override the
 * carrier-level allows the whitelist is otherwise made of, and banning a broker would be impossible.
 *
 * Ordered narrowest first. A broker sits inside exactly one integration, so it's more surgical than
 * one; a partner qualifier is about who we're quoting for rather than the rate itself, so it ranks
 * below both.
 */
export const ruleSpecificity = (rule: TruckingWhitelistRule) =>
  (rule.origin ? 16 : 0) +
  (rule.broker ? 8 : 0) +
  (rule.integration ? 4 : 0) +
  (rule.fpAccountId ? 2 : 0) +
  (rule.scac ? 1 : 0);
